import { FilterTabs } from '../ui/FilterTabs';

export const PACKAGE_VIEWS = [
  { value: 'audit', label: 'Audit' },
  { value: 'assets', label: 'Assets' },
];

/**
 * Audit | Assets view switcher for package detail (Sep 3 Disc slides 4–5).
 */
export function PackageViewSwitch({ value, onChange }) {
  return (
    <FilterTabs
      tabs={PACKAGE_VIEWS}
      value={value}
      onChange={onChange}
      ariaLabel="Package view"
    />
  );
}
